import axios from "axios";
import React, { useState, useEffect } from "react";
import { APIURL } from "../../redux/action/config";
import dateFormat from "dateformat";
import silverImg from "../../assets/images/silver.png";
import bronzeImg from "../../assets/images/bronze.png";
import goldImg from "../../assets/images/gold.png";
import loader from "../../components/loader/loader";
import NoImage from "../../assets/images/noimages.jpg";

const ViewCustomer = ({ viewDetails, modalId }) => {
  const customers = viewDetails ? viewDetails : "";
  const purchasedMembersjip = customers
    ? customers?.purched_memberships?.filter((m) => m.expired == "false")[0]
    : "";
  const getBadge = (status) => {
    switch (status) {
      case "available":
        return "success";
      case "busy":
        return "warning";
      default:
        return "primary";
    }
  };

  return (
    <React.Fragment>
      <div
        className="modal fade"
        id={modalId}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
                {viewDetails && customers?._id ? (
                  <form
                    id="kt_modal_new_target_form"
                    className="form fv-plugins-bootstrap5 fv-plugins-framework"
                    action="#"
                  >
                    <div className="mb-8 text-center">
                      <h1 className="mb-3 text-primary">
                        Customer Detail{" "}
                        <img
                          className="membership-badge"
                          src={
                            purchasedMembersjip?.name == "Roadside Assist"
                              ? bronzeImg
                              : purchasedMembersjip?.name == "Roadside Fleet"
                                ? goldImg
                                : purchasedMembersjip?.name == "Roadside Premier"
                                  ? silverImg
                                  : ""
                          }
                        />
                      </h1>
                    </div>
                    <div className="separator d-flex flex-center mb-8"></div>
                    <div className="row mb-5">
                      <div className="col-md-12 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Profile Picture</span>
                        </label>
                        <div>
                          <img
                            className="mw-150px"
                            src={customers.image ? APIURL + "/" + customers.image : NoImage}
                            alt="profile"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>First Name</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {customers?.firstName ? customers?.firstName : "N/A"}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Middle Name</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {customers?.middleName
                            ? customers?.middleName
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Last Name</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {customers?.lastName ? customers?.lastName : "N/A"}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Phone Number</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {customers?.phone ? customers?.phone : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Purchased Membership</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {purchasedMembersjip
                            ? purchasedMembersjip?.name
                            : "N/A"}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Email Address</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {customers?.email ? customers?.email : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-12 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Customer Notes</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {customers?.customerNotes
                            ? customers?.customerNotes
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      {/* <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Status</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold text-capitalize">
                          <span
                            className={`btn ${getBadge(
                              customers?.status
                            )} text-capitalize`}
                          >
                            {customers?.status}
                          </span>
                        </div>
                      </div> */}
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Joining Date</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {dateFormat(customers?.joi_date, "d mmmm , yyyy")}
                        </div>
                      </div>
                    </div>
                  </form>
                ) : (
                  loader()
                )}
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default ViewCustomer;
